<template>
  <b-progress
    v-if="showLoader"
    :class="getClass()"
    :value="counter"
    :max="max"
    :style="customStyle"
    animated></b-progress>
</template>

<script>
export default {
  name: 'progress-loader',
  props: {
    customClass: '',
    customStyle: ''
  },
  data () {
    return {
      counter: 45,
      max: 100,
      showLoader: false
    }
  },
  methods: {
    activateProgressBar () {
      this.counter = (Math.random() * this.max)
      this.showLoader = true
      // let loop = function myLoop (i) {
      //   setTimeout(function () {
      //     this.counter += 10
      //     if (--i) myLoop(i) //  decrement i and call myLoop again if i > 0
      //   }, 100)
      // }
      // loop(5) //  pass the number of iterations as an argument
      let objFooter = document.getElementsByClassName('card-footer')
      if (objFooter.length > 0) {
        let arrBtn = objFooter[0].getElementsByClassName('btn')
        for (let a of arrBtn) {
          a.disabled = true
        }
      }
    },
    deactivateProgressBar () {
      this.counter = this.max
      this.showLoader = false
      let objFooter = document.getElementsByClassName('card-footer')
      if (objFooter.length > 0) {
        let arrBtn = objFooter[0].getElementsByClassName('btn')
        for (let a of arrBtn) {
          a.disabled = false
        }
      }
    },
    getClass () {
      return 'animated ' + (this.showLoader ? '' : 'fade') + ' ' + this.customClass
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/components/progressLoader.vue